import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IControlSetDisplayView } from "../widget-control-set.models";
import { DashboardContextService } from "@main/reporting.v3/dashboard/api/dashboard-context.service";


@Injectable()
export class WidgetControlSetViewService extends BaseDataService {
    private dashboardContext = inject(DashboardContextService, { optional: true });

    readonly url = "api/reporting3/widget/control-set/data";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }


    getDisplayView(widgetSourceId: string): Promise<IControlSetDisplayView> {
        const headers = this.dashboardContext?.dashboardHeader;
        return this.handleRequest(this.http.get<IControlSetDisplayView>(`${this.url}/${widgetSourceId}/view`, { headers }));
    }
}